if (!customElements.get('product-card-slider')) {
  class ProductCardSlider extends HTMLElement {
    constructor() {
      super();
      this.swiper = null;
    }

    connectedCallback() {
      if (window.Swiper) {
        this.initSwiper();
      } else {
        window.addEventListener('swiperLoaded', () => this.initSwiper());
      }
    }

    initSwiper() {
      const swiperEl = this.querySelector('.product-card .swiper');
      if (!swiperEl) return;

      // Destroy if already initialized
      if (this.swiper) {
        this.swiper.destroy(true, true);
      }

      this.swiper = new Swiper(swiperEl, {
        slidesPerView: 1,
        spaceBetween: 0,
        speed: 500,
        loop: false,
        pagination: {
          el: this.querySelector('.swiper-pagination'),
          clickable: true,
          draggable: true
        },
        simulateTouch: true,
        touchRatio: 1,
        grabCursor: true,
        mousewheel: false,
        keyboard: false
      });

      if (window.innerWidth > 1024) {
        const card = swiperEl.closest('.product-card');
        card.addEventListener('mouseenter', () => {
          this.swiper.slideToLoop(1, 500, false);
        });
        card.addEventListener('mouseleave', () => {
          this.swiper.slideToLoop(0, 500, false);
        });
      }
    }

    // Public method to allow reinitialization
    reInitSwiper() {
      this.initSwiper();
    }
  }

  customElements.define('product-card-slider', ProductCardSlider);
}
